// const msg = [
//   "校内各预约人员：",
//   "鉴于当前疫情形势，在保障学校师生安全的前提下为方便校内各单位业务工作正常开展，现将校外人员预约事项提示如下：",
//   "一、根据学校疫情防控领导小组要求，各单位需要按照“一事一约、非必要不入校园、自行审核、存档备查”的原则进行预约；",
//   "二、行人预约平台仅可为与校内各部门有业务合作的校外人员、无工资号的外聘职工、未返聘的离校职工预约。学生进校请严格按照学工部、研工部、科研院等部门的相关通知执行；教职工进校请严格按照人力资源部的相关通知执行；",
//   "三、原则上来自中高风险地区所在设区市（直辖市为区)旅居史、中、高风险地区旅居史、境外返蓉人员不予预约进校；",
//   "四、如有特殊情况来自中高风险地区所在设区市（直辖市为区旅居史）、中、高风险地区旅居史、境外返蓉人员进校需申请审批，并根据要求提供相关材料。",
//   "（一）中、高风险地区旅居史及有中高风险地区所在设区市（直辖市为区）旅居史需提供48小时内核酸检测报告及解除隔离证明书；",
//   "（二）境外返蓉人员需提供核酸检测报告、集中和居家隔离的解除隔离证明书；",
//   "五、中高风险地区，及境外地区进校的校外人员需提供证明材料由各预约人员会同各单位自行存档备查；",
//   "六、校外人员进校将严格审核进校权限、核验健康记录、测温体温，三项均符合要求并登记后放行。请各单位给予理解和配合；",
//   "七、中高风险的区域划分参考学校“防控工作信息报告”微信群、微信小程序务院客户端的“疫情风险等级查询。"
// ];
const msg =
    `校内各单位管理员及在校师生：

为做好校园秩序管理工作，方便校内各单位及师生工作生活正常开展，现将校外人员预约事项提示如下：

一、需要按照“谁预约、谁负责，一事一约、自行审核”的原则进行预约；

二、如有涉及中小学生的研学活动，请在保卫处网站上下载【电子科技大学研学活动进校审批表】，并根据研学活动类型走校内审批流程后进校；

三、提醒进校人员自觉遵守法律法规和学校管理规定，共同维护良好的校园秩序。
`

const title = '预约须知'

export { msg, title }
